import './App.css';
import Products from './components/Products.jsx'

function App() {
  return (
    <>
      <Products />
    </>
  );
}

export default App;
